<div class="catalog-entry">
    <span class="name"></span>
    <span class="progress"></span>
    <span class="size"></span>
</div>